import { useTranslation } from 'react-i18next'

import { getFeaturedItemId } from '../utils'

import { Badge, Flex } from '@percent/lemonade'
import { FEATURED_KINDS, type GivingFeaturedConfigValue } from '@percent/admin-dashboard/api/types'

type FeaturedListProps = {
  items: GivingFeaturedConfigValue
}

export function FeaturedList({ items }: FeaturedListProps) {
  const { t } = useTranslation()

  // Group by kind in the canonical FEATURED_KINDS order; Array.sort is stable so items keep
  // their relative order within a kind. One badge per line for readability.
  const ordered = [...items].sort((a, b) => FEATURED_KINDS.indexOf(a.kind) - FEATURED_KINDS.indexOf(b.kind))

  return (
    <Flex direction="column" gap={1} align="flex-end">
      {ordered.map(item => (
        <Badge key={`${item.kind}-${getFeaturedItemId(item)}`} variant="default">
          {t(`partnerConfig.behaviour.featured.kind.${item.kind}`)}: {getFeaturedItemId(item)}
        </Badge>
      ))}
    </Flex>
  )
}
